import { differenceInMinutes, getUnixTime, subHours } from "date-fns";
import VueI18n, { TranslateResult } from "vue-i18n";

import { displayStatesUnion, i18nDateTimeFormat, timestamp } from "~/types/types";

export function formatDate(
  i18n: VueI18n,
  timestamp: timestamp,
  format: i18nDateTimeFormat = "medium",
): string {
  if (timestamp !== null) {
    return i18n.d(new Date(timestamp * 1000), format);
  }
  return "";
}

export function connectionTimeToState(updatedOn: timestamp): displayStatesUnion {
  const now = new Date();
  const time12hoursAgo = getUnixTime(subHours(now, 12));
  const time24hoursAgo = getUnixTime(subHours(now, 24));

  if (updatedOn >= time12hoursAgo) {
    return "ok";
  }
  if (updatedOn < time12hoursAgo && updatedOn >= time24hoursAgo) {
    return "warning";
  }
  if (updatedOn < time24hoursAgo) {
    return "error";
  }
}

export function isConnected(connectedOn: timestamp): boolean {
  if (!connectedOn) return false;
  return differenceInMinutes(new Date(), new Date(connectedOn * 1000)) < 30;
}

export function isRecent(connectedOn: timestamp): boolean {
  if (!connectedOn) return false;
  return differenceInMinutes(new Date(), new Date(connectedOn * 1000)) < 60;
}

export function getConnectionLabel(
  connectedOn: timestamp,
  i18n: VueI18n,
): string | TranslateResult {
  if (!connectedOn) return i18n.t("common.notConnected") as string;
  if (isConnected(connectedOn)) return i18n.t("common.connected") as string;
  if (isRecent(connectedOn)) {
    const minutes = differenceInMinutes(new Date(), new Date(connectedOn * 1000));
    return `${minutes} ${i18n.t("common.minutes")}`;
  }
  return formatDate(i18n, connectedOn);
}

export function getConnectionState(connectedOn: timestamp): displayStatesUnion {
  if (!connectedOn) return "disabled";
  if (isConnected(connectedOn)) return "ok";
  return "disabled";
}
